<template>
  <div v-if="flowTips.length > 0" class="flow-div" id="flow-div">
    <el-alert class="flow-tip" :title="info.title" :class="info.class" :type="info.type" v-for="(info, i) in flowTips"
      :key="i" show-icon :closable="false">
      <!-- <i class="flow-tip-close" @click="closeCurrentTip(info)">x</i> -->
      <span class="flow-tip-description" v-html="info.description" v-if="info.description"></span>
      <div class="flow-tip-btn-grpup" v-if="info.confirmBtnTxt || info.cancelBtnTxt">
        <el-button v-if="info.confirmBtnTxt" @click="handleBtnConfirm(info)"
          :class="{ 'flow-tip--btn--active': info.btnVal == '1' }">{{ info.confirmBtnTxt }}</el-button>
        <el-button v-if="info.cancelBtnTxt" @click="handleBtnCancel(info)"
          :class="{ 'flow-tip--btn--active': info.btnVal == '0' }">{{ info.cancelBtnTxt }}</el-button>
      </div>
    </el-alert>
  </div>
</template>

<script>

// tip = {
//   title:'显示内容',
//   type:'提示类型', success/warning/info/error
//   key:'当前提示内容的key值'
// }
export default {
  data () {
    return {
      flowTips: []
    };
  },
  watch: {
    flowTips (val) {
      val && (this.flowTips = val);
    }
  },
  methods: {
    handleBtnConfirm (item) {
      item.btnVal && (item.btnVal = "1");
      item.confirmedAction && item.confirmedAction.call(this, item);
    },
    handleBtnCancel (item) {
      item.btnVal && (item.btnVal = "0");
      item.canceldAction && item.canceldAction.call(this, item);
    },
    //返回准入项里 指定类型的项目 如果有就是对应项目的index 否则返回0
    getTypeLength (type) {
      return _.findIndex(this.flowTips, function (o) {
        return o.type == type;
      });
    },
    closeCurrentTip (info) {
      if (info.type != "error") {
        this.removeFlowTip(info.key);
      }
    },
    pushFlowTip (tip) {
      this.flowTips = _.chain(this.flowTips).concat(tip).uniqWith(function (arrVal, othVal) {
        return _.isEqualWith(arrVal, othVal, function () {
          return arrVal.key == othVal.key;
        });
      }).value();
      this.flowTips = this.flowTips.sort(function (a, b) {
        return (b.num || 0) - (a.num || 0);
      });
    },
    removeFlowTip (key) {
      if (typeof key == "string" || typeof key == "number") {
        this.flowTips = _.filter(this.flowTips, function (n) {
          return n.key != key;
        });
      }
      if (key instanceof Array) {
        this.flowTips = _.filter(this.flowTips, function (n) {
          return !key.includes(n.key);
        });
      }
    },
    removeAllFlowTip (){
      this.flowTips = [];
    },
    getErrFlowTip () {
      //校验flowtips 如果存在error类型则校验失败
      return this.getFlowTip(["error"]);
    },
    getFlowTip (types) {
      return _.filter(this.flowTips || [], v => types.includes(v.type)) || [];
    }
  }
};
</script>

<style lang="less" scoped>
#flow-div {
  position: relative;
  top: 0px;
  margin: 5px auto 10px;
  width: 100%;
  // box-sizing: border-box;
  /deep/ .flow-tip {
    height: auto;
    // margin: 0 0 10px;
    // padding: 18px 20px;
    width: 100%;
    border-radius: 4px;
    line-height: 1.2;
    font-size: 10px;
    &.el-alert--info {
      background: #f0f3f8;
      .el-alert__icon {
        color: #808992;
      }
      .el-alert__content {
        .el-alert__title {
          color: #343434;
        }
        .flow-tip-description {
          color: #343434;
        }
        .flow-tip-close {
          display: none;
        }
      }
    }
    &.el-alert--warning {
      border: 1px solid #ffd77a;
      background-color: #fff9e6;
      border-radius: 4px;
      .el-alert__icon {
        font-size: 12px;
        color: #fa6f01;
      }
      .el-alert__content {
        color: #515a6e;
        letter-spacing: 1px;
      }
    }
    &.el-alert--danger {
      background: rgba(227, 0, 0, 0.26);
      border: 1px solid #df3434;
      border-radius: 4px;
      .el-alert__icon {
        font-size: 12px;
        color: #e82d2d;
      }
      .el-alert__content {
        color: #e82d2d;
        letter-spacing: 1px;
      }
    }
    &.el-alert--error {
      background: rgba(227, 0, 0, 0.26);
      border: 1px solid #df3434;
      border-radius: 4px;
      .el-alert__icon {
        font-size: 12px;
        color: #e82d2d;
      }
      .el-alert__content {
        color: #e82d2d;
        letter-spacing: 1px;
      }
    }
    .el-alert__content {
      flex: 1;
      display: inline-flex;
      justify-content: space-between;
      align-items: center;
      .flow-tip-close {
        position: absolute;
        right: 0px;
        font-style: normal;
        display: flex;
        width: 40px;
        text-align: center;
        top: 0;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
      }
      .el-alert__title {
        font-size: 14px;
        line-height: 20px;
        font-weight: 400;
      }
      .flow-tip-btn-grpup {
        display: inline-flex;
        margin-left: 10px;
        .el-button {
          // width: 78px;
          height: 0.25rem;
          padding: 2px 10px;
          margin-right: 10px;
          border: 1PX solid rgba(159, 162, 174, 1);
          border-radius: 20px;
          font-size: 12px;
          color: #1062d1;
          border-color: rgba(16, 98, 209, 1);
          background-color: transparent;
          &:focus,
          &.flow-tip--btn--active {
            background: #c3d6f0;
            color: #1062d1;
            border-color: rgba(16, 98, 209, 1);
          }
        }
      }
    }
    &.el-alert.warn {
      background-color: #fadec3;
      .el-alert__icon {
        color: #ff7816;
      }
      .el-alert__title {
        color: #fa861b;
      }
    }
    .el-alert__icon{
      font-size: .12rem !important;
      width: 0.16rem !important;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/common/flowTip.vue